import React, { useState, useEffect } from "react";
import { ChoiceGroupWrap, ChoiceWrapper } from "components/atoms/MenuManagement/ChoiceGroup/ChoiceGroup.styles";
import Button from "components/molecules/Button";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import { useForm } from "components/molecules/Form";
import { FiSearch } from "react-icons/fi";
import {
  arrayMove,
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import handel from "assets/dragHandel.svg";
import deleteIcon from "assets/menu-delete.svg";

import {
  CategoryBody,
  FakeTabelBody,
  TableRowsWrapper,
} from "../MenuManagement.styles";
import ModalContainer from "components/molecules/ModalContainer";
import ChoiceModal from "components/atoms/MenuManagement/ChoiceModal";
import { FaRegEdit } from "react-icons/fa";
import DeleteModal from "components/atoms/DeleteModal/Index";
import { MdDelete } from "react-icons/md";
import menuStoreService from "services/menu-storeService";
import { useAuthContext } from "Context/authContext";
import { useSelector } from "react-redux";
import Toast from "components/molecules/Toast";

const DragHandle = sortableHandle(() => (
  <div className="fake-table-resp drag-handle2" style={{ userSelect: "none" }}>
    <span className="thead-row" style={{ userSelect: "none" }}>
      Choice Groups
    </span>
    <div
      className=""
      style={{
        marginRight: "10px",
        cursor: "move",
        flexShrink: "0",
      }}>
      <img src={handel} alt="handel" />
    </div>
  </div>
));
const Actions = ({ choiceGroup, onDelete, onEdit }) => {
  const handleDelete = async () => {
    try {
      const res = await menuStoreService.deleteChoiceGroup(choiceGroup._id);
      Toast({
        type: "success",
        message: res?.message || "Choice group deleted successfully",
      });
      onDelete();
    } catch (error) {
      Toast({
        type: "error",
        message: error?.message || "Failed to delete choice group",
      });
    }
  };

  return (
    <div className="action-btn">
      <ModalContainer
        width={850}
        title="Edit Choice Group"
        btnComponent={({ onClick }) => (
          <button className="edit" onClick={onClick}>
            <div>
              <FaRegEdit />
            </div>
          </button>
        )}
        content={({ onClose }) => (
          <ChoiceModal 
            editChoice={true} 
            choiceGroupData={choiceGroup}
            onClose={onClose}
            onSuccess={onEdit}
          />
        )}
      />
      <div className="delete">
        <ModalContainer
          width={450}
          noBorder
          btnComponent={({ onClick }) => (
            <button onClick={onClick}>
              <img src={deleteIcon} alt="delete-Icon" />
            </button>
          )}
          content={({ onClose }) => (
            <DeleteModal
              onSubmit={handleDelete}
              title="Are you sure you want to Delete this Choice Group?"
              successTitle="Choice Group Deleted Successfully!"
              onClose={onClose}
            />
          )}
        />
      </div>
    </div>
  );
};
const SortableItem = sortableElement(({ item, index, onDelete, onEdit, ...rest }) => {
  const availableChoices = item?.choices?.filter(choice => choice.availability === "Available") || [];
  const unavailableChoices = item?.choices?.filter(choice => choice.availability === "Unavailable") || [];
  
  const requirementText = item?.isRequired 
    ? `Required (Selected ${item?.minChoice}-${item?.maxChoice})` 
    : `Optional (Selected ${item?.minChoice}-${item?.maxChoice})`;

  return (
    <FakeTabelBody key={index} $choice>
      <div className="choice-name">
        <DragHandle />
        <div className="text">
          <strong className="title">{item?.groupName}</strong>
          <p>{requirementText}, {item?.choices?.length || 0} Choices</p>
        </div>
      </div>
      <div
        className="fake-table-resp drag-handle2"
        style={{ userSelect: "none" }}
      >
        <span className="thead-row" style={{ userSelect: "none" }}>
          Available Choices
        </span>
        <div className="choices">
          {availableChoices.map(choice => choice.choiceName).join(", ") || "None"}
        </div>
      </div>
      <div
        className="fake-table-resp drag-handle2"
        style={{ userSelect: "none" }}
      >
        <span className="thead-row" style={{ userSelect: "none" }}>
          Unavailable Choices
        </span>
        <div className="choices">
          <div className="choices">
            {unavailableChoices.map(choice => choice.choiceName).join(", ") || "None"}
          </div>
        </div>
      </div>
      <Actions choiceGroup={item} onDelete={onDelete} onEdit={onEdit} />
    </FakeTabelBody>
  );
});
const SortableContainer = sortableContainer(({ children }) => {
  return <TableRowsWrapper>{children}</TableRowsWrapper>;
});

const ChoiceGroup = ({ data }) => {
  const [choiceGroups, setChoiceGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { fetch } = useAuthContext();
  const { defaultStore } = useSelector(state => state.business);
  const { hasPermission } = useAuthContext("hasPermission");

  const [form] = useForm();

  const fetchChoiceGroups = async (search = "") => {
    if (!defaultStore) return;
    
    setLoading(true);
    try {
      const res = await menuStoreService.getChoiceGroups(defaultStore, search);
      setChoiceGroups(res?.data || []);
    } catch (error) {
      console.error("Error fetching choice groups:", error);
      Toast({
        type: "error",
        message: "Failed to fetch choice groups",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChoiceGroups(searchQuery);
  }, [defaultStore, searchQuery, fetch]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setChoiceGroups((prevState) => arrayMove(prevState, oldIndex, newIndex));
    // TODO: Implement API call to update order
  };

  const handleSearch = (values) => {
    setSearchQuery(values.search || "");
  };

  const handleDelete = () => {
    fetchChoiceGroups(searchQuery);
  };

  const handleEdit = () => {
    fetchChoiceGroups(searchQuery);
  };
  return (
    <>
      <ChoiceGroupWrap>
        <div className="text-wrap">
          <div className="left-content">
            <div className="heading">
              <strong>Choice Group</strong>
              <p>
                This is where you’ll find the groups of choices your customers
                can add to their items.
              </p>
            </div>
            <Form form={form} onFinish={handleSearch}>
              <Form.Item
                type="search"
                rounded
                name="search"
                lg
                placeholder="Search choice groups..."
                $bgWhite
                inputSm
                noMargin
                suffix={<FiSearch />}
              >
                <Field />
              </Form.Item>
            </Form>
          </div>
          <div className="right-content">
            {hasPermission("menu-management.add-choice-group") && (
              <ModalContainer
                width={850}
                title="Create Choice Group"
                btnComponent={({ onClick }) => (
                  <Button onClick={onClick}>Create Choice Group</Button>
                )}
                content={({ onClose }) => (
                  <ChoiceModal 
                    onClose={onClose} 
                    onSuccess={() => {
                      fetchChoiceGroups(searchQuery);
                      onClose();
                    }}
                  />
                )}
              />
            )}
          </div>
        </div>
      </ChoiceGroupWrap>

      <CategoryBody $choice>
        <ChoiceWrapper>
          <strong>Choice Groups</strong>
          <strong className="available">Available Choices</strong>
          <strong className="unavailable">Unavailable Choices</strong>
          <strong>Actions</strong>
        </ChoiceWrapper>
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            Loading choice groups...
          </div>
        ) : choiceGroups.length > 0 ? (
          <SortableContainer onSortEnd={onSortEnd} useDragHandle>
            {choiceGroups.map((item, ind) => (
              <SortableItem 
                key={item._id}
                item={item} 
                index={ind} 
                onDelete={handleDelete}
                onEdit={handleEdit}
              />
            ))}
          </SortableContainer>
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            {searchQuery ? "No choice groups found matching your search." : "No choice groups found. Create your first choice group!"}
          </div>
        )}
      </CategoryBody>
    </>
  );
};

export default ChoiceGroup;
